import { render } from "./TableOutputFile.vue?vue&type=template&id=ed3bccb0"
import script from "./TableOutputFile.vue?vue&type=script&lang=js"
export * from "./TableOutputFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__